import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgDropDownComponent } from './pg-drop-down.component';
import { PgDropDownItemDirective } from './pg-drop-down-item.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PgDropDownComponent, PgDropDownItemDirective],
  exports: [PgDropDownComponent, PgDropDownItemDirective],
})
export class PgDropDownModule {}
